module.exports = __webpack_public_path__ + "04_short_beige.f30b8914.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/04_short_beige.png
// module id = im5q
// module chunks = 0